export default __webpack_public_path__ + "static/media/logoLine.72fcf2b7.webp";